import Immutable from 'seamless-immutable';

const parseVoteString = voteString => {
  const [itemId, changeString] = voteString.split(',');
  return [itemId, +changeString];
};

const loadVotes = (state, votes) => {
  if (Object.keys(votes).length === 0) {
    return state;
  }

  const loadVoteAndCheckEmpty = (state, path, votes) => {
    const item = Immutable.getIn(state, path);
    const vote = votes[item.key];
    if (typeof vote !== 'undefined') {
      state = Immutable.setIn(state, [].concat(path, ['myVote']), vote);
      delete votes[item.key];
    }
    return state;
  };

  const { questions } = state;
  for (let i = 0; i < questions.length; ++i) {
    state = loadVoteAndCheckEmpty(state, ['questions', i], votes);
    if (Object.keys(votes).length === 0) {
      return state;
    }
    const { answers } = questions[i];
    for (let j = 0; j < answers.length; ++j) {
      state = loadVoteAndCheckEmpty(state, ['questions', i, 'answers', j], votes);
      if (Object.keys(votes).length === 0) {
        return state;
      }
    }
  }
  return state;
};

export default function processVotes(state, data) {
  if (state.askError) {
    return state;
  }
  const votes = data.qaidList.reduce((acc, voteString) => {
    const [itemId, change] = parseVoteString(voteString);
    acc[itemId] = change;
    return acc;
  }, {});
  state = loadVotes(state, votes);
  return Immutable.set(state, 'authenticated', true);
}
